import styled from "styled-components";

export const StyledSpanLink = styled.span`
  font-size: inherit;
  /* underline only here on the root: a descendant span selector makes every
     nested Slate span its own decorating box, and a box inside <em> positions
     its line by the italic face's metrics - mid font-load that face is a
     fallback whose offset differs, painting a second line a few px below */
  text-decoration: underline;
  color: #0073ca;
  cursor: pointer;
  /* BV's aero interactive plugin rendered this link as an atomic inline
     (display: inline-flex) up to 0.15.526; from 0.15.527 (Sep 2026 exports) it
     is a plain inline. Express mirrored the old atomic behaviour with
     inline-block, which against current BV produces three wrap differences:
     Chrome breaks between a preceding no-break space and the atomic box
     ("See\u00a0" | "Real Marketing 4.2"), never breaks inside the link
     ("Chapter " / "14"), and orphans trailing punctuation onto the next line
     ("...on Earth" | "."). A plain inline follows the same line-breaking rules
     as BV's link. */
  display: inline;
`;
